<template>
    <b-row>
        <!-- MENSAGENS -->

        <mensagens-dash
            :qtd="qtdMensagensNaoLidas"
            :loading="loading"
            v-if="$temAcessoView('MENSAGENS-00')"
        ></mensagens-dash>

        <!-- PAGAMENTOS GERAIS -->

        <pagamentos-dash
            :qtd="qtdPagamentosProgramados"
            :loading="loading"
            v-if="$temAcessoView('FORN-PAG-00')"
        ></pagamentos-dash>

        <!-- GESCON FORNECEDORES -->
        <contratos-dash
            v-if="$temAcessoView('FORN-CONTRATOS-00')"
        ></contratos-dash>
        <gescon-pagamentos-dash
            v-if="$temAcessoView('GESCON-FORN-PAG-00')"
        ></gescon-pagamentos-dash>

        <!-- GESCON GESTORES -->
        <gescon-gestores-contratos-dash
            v-if="$temAcessoView('GESCON-GEST-CONT-00')"
        >
        </gescon-gestores-contratos-dash>
        <gescon-gestores-requisicoes-dash
            v-if="$temAcessoView('GESCON-GEST-REQ-00')"
            :qtd="qtdRequisicoesContratosEmAnalise"
            :loading="loading"
        >
        </gescon-gestores-requisicoes-dash>
        <gescon-gestores-pagamentos-dash
            v-if="$temAcessoView('GESCON-GEST-PAG-00')"
        >
        </gescon-gestores-pagamentos-dash>

        <!-- GESCON GERENTES -->
        <gescon-gerentes-contratos-dash
            v-if="$temAcessoView('GESCON-GER-CONT-00')"
        >
        </gescon-gerentes-contratos-dash>
        <gescon-gerentes-requisicoes-dash
            v-if="$temAcessoView('GESCON-GER-REQ-00')"
            :qtd="qtdRequisicoesContratosEmAnalise"
            :loading="loading"
        >
        </gescon-gerentes-requisicoes-dash>
        <gescon-gerentes-pagamentos-dash
            v-if="$temAcessoView('GESCON-GER-PAG-00')"
        >
        </gescon-gerentes-pagamentos-dash>
        <gescon-gerentes-apoios-dash
            v-if="$temAcessoView('GESCON-GER-APOIO-00')"
        >
        </gescon-gerentes-apoios-dash>

        <!-- GESCON APOIOS -->
        <gescon-apoios-contratos-dash
            v-if="$temAcessoView('GESCON-APOIO-CONT-00')"
        ></gescon-apoios-contratos-dash>
        <gescon-apoios-requisicoes-dash
            v-if="$temAcessoView('GESCON-APOIO-CONT-00')"
        ></gescon-apoios-requisicoes-dash>
        <gescon-apoios-pagamentos-dash
            v-if="$temAcessoView('GESCON-APOIO-CONT-00')"
        ></gescon-apoios-pagamentos-dash>

        <!-- GESCON UFI -->
        <gescon-financeiro-pagamentos
            :qtd="qtdPagamentosEmAnaliseGescon"
            :qtd2="qtdPagamentosAguardandoFinanceiroGescon"
            :loading="loading"
            v-if="$temAcessoView('GESCON-UFI-PAG-00')"
        ></gescon-financeiro-pagamentos>

        <!-- GESCON APROVADORES -->

        <gescon-comprometimentos-aprovador
            :qtd="qtdComprometimentosEmAnaliseGescon"
            :loading="loading"
            v-if="$temAcessoView('GESCON-COMP-APROV-00')"
        ></gescon-comprometimentos-aprovador>

        <!-- SGF FORNECEDORES -->

        <credenciado-contratacoes-dash
            v-if="$temAcessoView('CRED-FORN-CONT-00')"
        ></credenciado-contratacoes-dash>
        <credenciado-finalizacoes-dash
            v-if="$temAcessoView('CRED-FORN-FIN-00')"
        ></credenciado-finalizacoes-dash>

        <!-- SGF GESTOR -->

        <gestores-contratacoes-dash
            v-if="$temAcessoView('CRED-GEST-CONT-00')"
        ></gestores-contratacoes-dash>
        <gestores-entregas-dash
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-dash>
        <gestores-solicitacoes-aditivos
            v-if="$temAcessoView('CRED-GEST-ADIT-00')"
        ></gestores-solicitacoes-aditivos>
        <sgf-gestores-entregas-solicitacoes-reaberturas
            v-if="$temAcessoView('CRED-GEST-ENTR-06')"
        ></sgf-gestores-entregas-solicitacoes-reaberturas>
        <gestores-painel-erros-comprometimentos-dash
            v-if="$temAcessoView('CRED-GEST-PNL-01')"
        ></gestores-painel-erros-comprometimentos-dash>
        <gestores-contratacoes-sem-avaliacao-dash
            :qtd="qtdContratacoesSemAvaliacao"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-contratacoes-sem-avaliacao-dash>
        <gestores-entregas-sem-comprometimento-dash
            :qtd="qtdEntregasSemComprometimento"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-sem-comprometimento-dash>
        <gestores-entregas-erro-comprometimento-dash
            :qtd="qtdEntregasErroComprometimento"
            v-if="$temAcessoView('CRED-GEST-ENTR-00')"
        ></gestores-entregas-erro-comprometimento-dash>
        <gestores-contratacoes-vencimento-01-dash
            :qtd="qtdContratacoesVencimentoEntre14e10Dias"
            v-if="$temAcessoView('CRED-GEST-CONT-00')"
        ></gestores-contratacoes-vencimento-01-dash>

        <!-- SGF GERENTES -->

        <gerentes-contratacoes-dash
            v-if="$temAcessoView('CRED-GER-CONT-00')"
        ></gerentes-contratacoes-dash>
        <gerentes-entregas-dash
            v-if="$temAcessoView('CRED-GER-ENTR-00')"
        ></gerentes-entregas-dash>
        <sgf-gerentes-entregas-solicitacoes-reaberturas
            v-if="$temAcessoView('CRED-GER-ENTR-02')"
            :qtd="qtdSolicitacoesReaberturasEmAnalisePeloGerente"
            :loading="loading"
        ></sgf-gerentes-entregas-solicitacoes-reaberturas>
        <gerentes-apoios-dash
            v-if="$temAcessoView('CRED-GER-APOIO-00')"
        ></gerentes-apoios-dash>
        <gestores-designados-dash
            v-if="$temAcessoView('CRED-GER-GEST-00')"
        ></gestores-designados-dash>

        <!-- SGF UABS -->

        <uabs-contratacoes-dash
            v-if="$temAcessoView('CRED-UABS-CONT-00')"
        ></uabs-contratacoes-dash>
        <uabs-finalizacoes-dash
            :qtd="qtdPagamentosEmAnaliseUabsSgf"
            :loading="loading"
            v-if="$temAcessoView('CRED-UABS-FIN-00')"
        ></uabs-finalizacoes-dash>
        <ufi-finalizacoes-dash
            :qtd="qtdPagamentosEmAnaliseUfiSgf"
            :qtd2="qtdPagamentosAguardandoFinanceiroUfiSgf"
            :loading="loading"
            v-if="$temAcessoView('CRED-UFI-FIN-00')"
        ></ufi-finalizacoes-dash>
        <uabs-solicitacoes-aditivos
            v-if="$temAcessoView('CRED-UABS-ADIT-00')"
            :qtd="qtdSolicitacoesAditivosEmProcessamento"
            :loading="loading"
        ></uabs-solicitacoes-aditivos>
        <sgf-uabs-entregas-solicitacoes-reaberturas
            :qtd="qtdSolicitacoesReaberturasEmAnalisePelaUabs"
            :loading="loading"
            v-if="$temAcessoView('CRED-UABS-ENTR-06')"
        ></sgf-uabs-entregas-solicitacoes-reaberturas>

        <!-- SGF APOIOS -->

        <apoios-contratacoes-dash
            v-if="$temAcessoView('CRED-APOIO-CONT-00')"
        ></apoios-contratacoes-dash>

        <!-- SGTEC FORNECEDORES -->

        <sgtec-projetos-dash
            v-if="$temAcessoView('SGTEC-FORN-PRJ-00')"
        ></sgtec-projetos-dash>
        <sgtec-pagamentos-dash
            v-if="$temAcessoView('SGTEC-FORN-PAG-00')"
        ></sgtec-pagamentos-dash>

        <!-- SGTEC GESTORES -->

        <sgtec-gestores-projetos-dash
            v-if="$temAcessoView('SGTEC-GEST-PRJ-00')"
        ></sgtec-gestores-projetos-dash>
        <sgtec-gestores-pagamentos-dash
            v-if="$temAcessoView('SGTEC-GEST-PAG-00')"
        ></sgtec-gestores-pagamentos-dash>
        <sgtec-gestores-etapas-dash01
            :qtd="qtdEtapasVencimentoEntre14e10diasNaoMarcadasNaoAditivar"
            v-if="$temAcessoView('SGTEC-GEST-ETP-01')"
            :loading="loading"
        ></sgtec-gestores-etapas-dash01>
        <sgtec-gestores-painel-erros-comprometimentos-dash
            v-if="$temAcessoView('SGTEC-GEST-PNL-01')"
        ></sgtec-gestores-painel-erros-comprometimentos-dash>

        <!-- SGTEC GERENTES -->

        <sgtec-gerentes-projetos-dash
            v-if="$temAcessoView('SGTEC-GER-PRJ-00')"
        ></sgtec-gerentes-projetos-dash>
        <sgtec-gerentes-pagamentos-dash
            v-if="$temAcessoView('SGTEC-GER-PAG-00')"
        ></sgtec-gerentes-pagamentos-dash>
        <sgtec-gerentes-apoios-dash
            v-if="$temAcessoView('SGTEC-GER-APOIO-00')"
        ></sgtec-gerentes-apoios-dash>

        <!-- SGTEC APOIOS -->

        <sgtec-apoios-projetos-dash
            v-if="$temAcessoView('SGTEC-APOIO-PRJ-00')"
        ></sgtec-apoios-projetos-dash>
        <sgtec-apoios-pagamentos-dash
            v-if="$temAcessoView('SGTEC-APOIO-PAG-00')"
        ></sgtec-apoios-pagamentos-dash>

        <!-- SGTEC UABS -->

        <sgtec-uabs-projetos-dash
            v-if="$temAcessoView('SGTEC-UABS-PRJ-00')"
        ></sgtec-uabs-projetos-dash>
        <sgtec-uabs-pagamentos-dash
            :qtd="qtdPagamentosEmAnaliseUabsSgtec"
            :loading="loading"
            v-if="$temAcessoView('SGTEC-UABS-PAG-00')"
        ></sgtec-uabs-pagamentos-dash>

        <!-- SGTEC UFI -->

        <sgtec-ufi-pagamentos-dash
            :qtd="qtdPagamentosEmAnaliseUfiSgtec"
            :qtd2="qtdPagamentosAguardandoFinanceiroUfiSgtec"
            :loading="loading"
            v-if="$temAcessoView('SGTEC-UFI-PAG-00')"
        ></sgtec-ufi-pagamentos-dash>

        <!-- DESPESAS GERAIS -->

        <despesas-requisitante-dash
            v-if="$temAcessoView('DESP-GERAIS-REQ-00')"
        ></despesas-requisitante-dash>
        <despesas-fornecedor-dash
            v-if="$temAcessoView('DESP-GERAIS-FORN-00')"
        ></despesas-fornecedor-dash>
        <despesas-demandante-dash
            v-if="$temAcessoView('DESP-GERAIS-DEMAN-00')"
            :qtd="qtdDespesasEmAnaliseDemanDespesasGerais"
            :loading="loading"
        ></despesas-demandante-dash>
        <despesas-gerente-dash
            v-if="$temAcessoView('DESP-GERAIS-GER-00')"
            :qtd="qtdDespesasEmAnaliseGerDespesasGerais"
            :loading="loading"
        ></despesas-gerente-dash>
        <despesas-finalizacao-dash
            v-if="$temAcessoView('DESP-GERAIS-FINAL-00')"
        ></despesas-finalizacao-dash>
        <despesas-financeiro-dash
            v-if="$temAcessoView('DESP-GERAIS-FINAN-00')"
        ></despesas-financeiro-dash>

        <despesas-pagamentos-finalizacao-dash
            v-if="$temAcessoView('DESP-GERAIS-FINAL-PAG-00')"
            :qtd="qtdPagamentosEmAnaliseUabsDespesasGerais"
            :loading="loading"
        ></despesas-pagamentos-finalizacao-dash>
        <despesas-pagamentos-financeiro-dash
            v-if="$temAcessoView('DESP-GERAIS-FINAN-PAG-00')"
            :qtd="qtdPagamentosEmAnaliseUfiDespesasGerais"
            :qtd2="qtdPagamentosAguardandoFinanceiroUfiDespesasGerais"
            :loading="loading"
        ></despesas-pagamentos-financeiro-dash>
        <despesas-pagamentos-requisitante-dash
            v-if="$temAcessoView('DESP-GERAIS-REQ-PAG-00')"
        ></despesas-pagamentos-requisitante-dash>
        <despesas-pagamentos-fornecedores-dash
            v-if="$temAcessoView('DESP-GERAIS-FORN-PAG-00')"
        ></despesas-pagamentos-fornecedores-dash>
        <despesas-pagamentos-demandantes-dash
            v-if="$temAcessoView('DESP-GERAIS-DEMAN-PAG-00')"
        ></despesas-pagamentos-demandantes-dash>
        <despesas-pagamentos-gerentes-dash
            v-if="$temAcessoView('DESP-GERAIS-GER-PAG-00')"
        ></despesas-pagamentos-gerentes-dash>
        <!-- APP FORNECEDORES -->

        <app-sebrae-consultorias-solicitacoes-dash
            v-if="$temAcessoView('APPSE-FORN-CONS-00')"
        ></app-sebrae-consultorias-solicitacoes-dash>
        <app-sebrae-consultorias-dash
            v-if="$temAcessoView('APPSE-FORN-CONS-00')"
        ></app-sebrae-consultorias-dash>
        <app-sebrae-consultorias-pagamentos-dash
            v-if="$temAcessoView('APPSE-FORN-PAG-00')"
        ></app-sebrae-consultorias-pagamentos-dash>

        <!-- APP UABS -->

        <app-sebrae-consultorias-uabs-dash
            v-if="$temAcessoView('APPSE-UABS-CONS-00')"
        ></app-sebrae-consultorias-uabs-dash>
        <app-sebrae-consultorias-uabs-pagamentos-dash
            v-if="$temAcessoView('APPSE-UABS-PAG-00')"
        ></app-sebrae-consultorias-uabs-pagamentos-dash>

        <!-- ADMINISTRACAO FORNECEDORES -->

        <dados-cadastrais-dash
            v-if="$temAcessoView('FORN-DADOS-00')"
        ></dados-cadastrais-dash>
        <certidoes-dash v-if="$temAcessoView('FORN-CERT-00')"></certidoes-dash>
        <fornecedores-dirfs-dash
            v-if="$temAcessoView('FORN-DIRF-00')"
        ></fornecedores-dirfs-dash>
        <fornecedores-usuarios-dash
            v-if="$temAcessoView('FORN-USR-00')"
        ></fornecedores-usuarios-dash>

        <!-- ADMINISTRACAO SEBRAE -->

        <fornecedores-dash
            v-if="$temAcessoView('GEST-FORNECEDORES-00')"
        ></fornecedores-dash>
        <atualizacoes-cadastrais-dash
            v-if="$temAcessoView('GEST-DADOS-00')"
            :qtd="qtdAtualizacoesCadastraisEmAprovacao"
            :loading="loading"
        ></atualizacoes-cadastrais-dash>
        <solicitacoes-acesso-dash
            v-if="$temAcessoView('CTRLACS-SOLACS-00')"
            :qtd="qtdSolicitacoesAcessoEmAprovacao"
            :loading="loading"
        ></solicitacoes-acesso-dash>
        <dirfs-dash v-if="$temAcessoView('DIRFS-00')"></dirfs-dash>
        <usuarios-dash v-if="$temAcessoView('CTRLACS-USR-00')"></usuarios-dash>
        <base-conhecimento-dash></base-conhecimento-dash>
        <pesquisas-dash
            titulo="PESQUISA DE USABILIDADE"
            :tipo="1"
        ></pesquisas-dash>
        <pesquisas-dash2
            v-if="$temAcessoView('PESQUISAS-00')"
        ></pesquisas-dash2>

        <!-- ESTATISTICAS -->

        <total-acessos
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessos"
        ></total-acessos>
        <total-acessos-ano
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessosAno"
        ></total-acessos-ano>
        <total-acessos-mes
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdTotalAcessosMes"
        ></total-acessos-mes>
        <novos-fornecedores-ano
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdNovosFornecedoresAno"
        ></novos-fornecedores-ano>
        <novos-fornecedores-mes
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdNovosFornecedoresMes"
        ></novos-fornecedores-mes>
        <solicitacoes-acesso-ano-dash
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdSolicitacoesAcessoAno"
        ></solicitacoes-acesso-ano-dash>
        <solicitacoes-acesso-mes-dash
            v-if="$temAcessoView('GEST-ESTATISTICA-00')"
            :qtd="qtdSolicitacoesAcessoMes"
        ></solicitacoes-acesso-mes-dash>
    </b-row>
</template>

<script>
import DashboardServicos from './DashboardServicos'

//Geral
import MensagensDash from './../mensagens/MensagensDash'
import PleitosDash from './../pleitos/PleitosDash'
import BaseConhecimentoDash from './../baseconhecimento/BaseConhecimentoDash'
import PesquisasDash from './../pesquisas/PesquisasDash'
import PesquisasDash2 from './../pesquisas/PesquisasDash2'

// Fornecedores
import PagamentosDash from './../fornecedor/pagamentos/PagamentosDash'
import DadosCadastraisDash from './../fornecedor/dadoscadastrais/DadosCadastraisDash'
import ContratosDash from './../fornecedor/contratos/ContratosDash'
import FornecedoresDirfsDash from './../fornecedor/dirfs/DirfsDash'
import FornecedoresUsuariosDash from './../fornecedor/usuarios/UsuariosDash'
import CredenciadoContratacoesDash from './../credenciados/fornecedores/contratacoes/ContratacoesDash'
import CredenciadoFinalizacoesDash from './../credenciados/fornecedores/finalizacoes/FinalizacoesDash'
import CertidoesDash from './../fornecedor/certidoes/CertidoesDash'
import SgtecProjetosDash from './../sgtec/fornecedores/projetos/ProjetosDash'
import SgtecPagamentosDash from './../sgtec/fornecedores/pagamentos/PagamentosDash'
import GesconPagamentosDash from '../fornecedor/contratos/pagamentos/PagamentosDash'

// Gestao
import AtualizacoesCadastraisDash from './../atualizacoescadastrais/AtualizacoesCadastraisDash'
import SolicitacoesAcessoDash from './../ctrlacesso/solicitacoesacesso/SolicitacoesAcessoDash'
import DirfsDash from './../dirfs/DirfsDash'
import UsuariosDash from './../ctrlacesso/usuarios/UsuariosDash'
import FornecedoresDash from './../fornecedores/FornecedoresDash'
import UabsContratacoesDash from './../credenciados/uabs/contratacoes/ContratacoesDash'
import UabsFinalizacoesDash from './../credenciados/uabs/finalizacoes/FinalizacoesDash'
import UfiFinalizacoesDash from './../credenciados/uabs/finalizacoes/FinalizacoesDashUfi'
import GestoresContratacoesDash from './../credenciados/gestores/contratacoes/ContratacoesDash'
import GestoresEntregasDash from './../credenciados/gestores/entregas/EntregasDash'
import GestoresPainelErrosComprometimentosDash from './../credenciados/gestores/paineis/PainelErrosComprometimentosDash'
import TotalAcessos from './../ctrlacesso/login/TotalAcessosDash'
import TotalAcessosAno from './../ctrlacesso/login/TotalAcessosAnoDash'
import TotalAcessosMes from './../ctrlacesso/login/TotalAcessosMesDash'
import NovosFornecedoresAno from './NovosFornecedoresAnoDash'
import NovosFornecedoresMes from './NovosFornecedoresMesDash'
import SolicitacoesAcessoAnoDash from './SolicitacoesAcessoAnoDash'
import SolicitacoesAcessoMesDash from './SolicitacoesAcessoMesDash'
import GerentesContratacoesDash from './../credenciados/gerentes/contratacoes/ContratacoesDash'
import GerentesEntregasDash from './../credenciados/gerentes/entregas/EntregasDash'
import GerentesApoiosDash from './../credenciados/gerentes/apoios/ApoiosDash'
import ApoiosContratacoesDash from './../credenciados/apoios/contratacoes/ContratacoesDash'
import GestoresDesignadosDash from './../credenciados/gerentes/gestoresdesignados/GestoresDesignadosDash'
import SgtecUabsProjetosDash from './../sgtec/uabs/projetos/ProjetosDash'
import SgtecUabsPagamentosDash from './../sgtec/uabs/pagamentos/PagamentosDash'
import SgtecUfiPagamentosDash from './../sgtec/uabs/pagamentos/PagamentosDashUfi'
import SgtecGestoresProjetosDash from './../sgtec/gestores/projetos/ProjetosDash'
import SgtecGestoresEtapasDash01 from './../sgtec/gestores/EtapasVencimentoEntre14e10DiasNaoMarcadasNaoAditivarDash'
import GestoresContratacoesSemAvaliacaoDash from './../credenciados/gestores/ContratacoesSemAvaliacaoDash'
import GestoresEntregasSemComprometimentoDash from './../credenciados/gestores/EntregasSemComprometimentoDash'
import GestoresEntregasErroComprometimentoDash from './../credenciados/gestores/EntregasErroComprometimentoDash'
import GestoresContratacoesVencimento01Dash from './../credenciados/gestores/ContratacoesVencimentoEntre14e10DiasDash'
import GestoresSolicitacoesAditivos from '../credenciados/gestores/solicitacoesaditivos/SolicitacoesAditivosDash'
import UabsSolicitacoesAditivos from '../credenciados/uabs/solicitacoesaditivos/SolicitacoesAditivosDash'
import GesconComprometimentosAprovador from '../gescon/aprovadores/ComprometimentosDash'
import GesconFinanceiroPagamentos from '../gescon/financeiro/pagamentos/PagamentosDash'
import SgfGestoresEntregasSolicitacoesReaberturas from '../credenciados/gestores/solicitacoesreaberturas/SolicitacoesReaberturasDash'
import SgfGerentesEntregasSolicitacoesReaberturas from '../credenciados/gerentes/solicitacoesreaberturas/SolicitacoesReaberturasDash'
import SgfUabsEntregasSolicitacoesReaberturas from '../credenciados/uabs/solicitacoesreaberturas/SolicitacoesReaberturasDash'
import SgtecGestoresPagamentosDash from './../sgtec/gestores/pagamentos/PagamentosDash'
import SgtecGerentesProjetosDash from './../sgtec/gerentes/projetos/ProjetosDash'
import SgtecGerentesPagamentosDash from './../sgtec/gerentes/pagamentos/PagamentosDash'
import SgtecGerentesApoiosDash from './../sgtec/gerentes/apoios/ApoiosDash'
import SgtecApoiosProjetosDash from './../sgtec/apoios/projetos/ProjetosDash'
import SgtecApoiosPagamentosDash from './../sgtec/apoios/pagamentos/PagamentosDash'
import SgtecGestoresPainelErrosComprometimentosDash from './../sgtec/gestores/paineis/PainelErrosComprometimentosDash'

//DESPESAS GERAIS
import DespesasRequisitanteDash from '../despesasgerais/requisitantes/despesas/DespesasDash.vue'
import DespesasFornecedorDash from '../despesasgerais/fornecedores/despesas/DespesasDash.vue'
import DespesasDemandanteDash from '../despesasgerais/demandantes/despesas/DespesasDash.vue'
import DespesasGerenteDash from '../despesasgerais/gerentes/despesas/DespesasDash.vue'
import DespesasFinalizacaoDash from '../despesasgerais/finalizacao/despesas/DespesasDash.vue'
import DespesasFinanceiroDash from '../despesasgerais/financeiro/despesas/DespesasDash.vue'
import DespesasPagamentosFinalizacaoDash from '../despesasgerais/finalizacao/pagamento/PagamentosDash.vue'
import DespesasPagamentosFinanceiroDash from '../despesasgerais/financeiro/pagamento/PagamentosDash.vue'
import DespesasPagamentosRequisitanteDash from '../despesasgerais/requisitantes/pagamento/PagamentosDash.vue'
import DespesasPagamentosFornecedoresDash from '../despesasgerais/fornecedores/pagamento/PagamentosDash.vue'
import DespesasPagamentosDemandantesDash from '../despesasgerais/demandantes/pagamento/PagamentosDash.vue'
import DespesasPagamentosGerentesDash from '../despesasgerais/gerentes/pagamento/PagamentosDash.vue'

//GESCON
import GesconGestoresContratosDash from '../gescon/gestores/contratos/ContratosDash'
import GesconGestoresRequisicoesDash from '../gescon/gestores/requisicoes/RequisicoesDash'
import GesconGestoresPagamentosDash from '../gescon/gestores/pagamentos/PagamentosDash'
import GesconGerentesContratosDash from '../gescon/gerentes/contratos/ContratosDash'
import GesconGerentesRequisicoesDash from '../gescon/gerentes/requisicoes/RequisicoesDash'
import GesconGerentesPagamentosDash from '../gescon/gerentes/pagamentos/PagamentosDash'
import GesconGerentesApoiosDash from '../gescon/gerentes/apoios/ApoiosDash'
import GesconApoiosContratosDash from '../gescon/apoios/contratos/ContratosDash.vue'
import GesconApoiosRequisicoesDash from '../gescon/apoios/requisicoes/RequisicoesDash.vue'
import GesconApoiosPagamentosDash from '../gescon/apoios/pagamentos/PagamentosDash.vue'

//App Sebrae
import AppSebraeConsultoriasSolicitacoesDash from '../appsebrae/consultorias/fornecedores/consultorias/SolicitacoesDash'
import AppSebraeConsultoriasDash from '../appsebrae/consultorias/fornecedores/consultorias/ConsultoriasDash'
import AppSebraeConsultoriasPagamentosDash from '../appsebrae/consultorias/fornecedores/pagamentos/PagamentosDash'
import AppSebraeConsultoriasUabsDash from '../appsebrae/consultorias/uabs/consultorias/ConsultoriasDash'
import AppSebraeConsultoriasUabsPagamentosDash from '../appsebrae/consultorias/uabs/pagamentos/PagamentosDash'

export default {
    components: {
        PagamentosDash,
        DadosCadastraisDash,
        ContratosDash,
        FornecedoresDirfsDash,
        FornecedoresUsuariosDash,
        FornecedoresDash,
        AtualizacoesCadastraisDash,
        SolicitacoesAcessoDash,
        DirfsDash,
        UsuariosDash,
        UabsContratacoesDash,
        UabsFinalizacoesDash,
        UfiFinalizacoesDash,
        CredenciadoContratacoesDash,
        CredenciadoFinalizacoesDash,
        GestoresContratacoesDash,
        GestoresEntregasDash,
        GestoresPainelErrosComprometimentosDash,
        CertidoesDash,
        TotalAcessos,
        TotalAcessosAno,
        TotalAcessosMes,
        NovosFornecedoresAno,
        NovosFornecedoresMes,
        SolicitacoesAcessoAnoDash,
        SolicitacoesAcessoMesDash,
        MensagensDash,
        PleitosDash,
        GerentesContratacoesDash,
        GerentesEntregasDash,
        GerentesApoiosDash,
        ApoiosContratacoesDash,
        GestoresDesignadosDash,
        SgtecProjetosDash,
        SgtecPagamentosDash,
        SgtecUabsProjetosDash,
        SgtecUabsPagamentosDash,
        SgtecUfiPagamentosDash,
        GestoresContratacoesSemAvaliacaoDash,
        GestoresEntregasSemComprometimentoDash,
        GestoresEntregasErroComprometimentoDash,
        BaseConhecimentoDash,
        PesquisasDash,
        PesquisasDash2,
        GestoresContratacoesVencimento01Dash,
        GestoresSolicitacoesAditivos,
        UabsSolicitacoesAditivos,
        AppSebraeConsultoriasSolicitacoesDash,
        AppSebraeConsultoriasDash,
        AppSebraeConsultoriasPagamentosDash,
        GesconComprometimentosAprovador,
        GesconPagamentosDash,
        GesconFinanceiroPagamentos,
        AppSebraeConsultoriasUabsDash,
        AppSebraeConsultoriasUabsPagamentosDash,
        SgtecGestoresProjetosDash,
        SgfGestoresEntregasSolicitacoesReaberturas,
        SgfGerentesEntregasSolicitacoesReaberturas,
        SgfUabsEntregasSolicitacoesReaberturas,
        SgtecGestoresPagamentosDash,
        SgtecGerentesProjetosDash,
        SgtecGerentesPagamentosDash,
        SgtecGerentesApoiosDash,
        SgtecApoiosProjetosDash,
        SgtecApoiosPagamentosDash,
        GesconGestoresContratosDash,
        GesconGestoresRequisicoesDash,
        GesconGestoresPagamentosDash,
        GesconGerentesContratosDash,
        GesconGerentesRequisicoesDash,
        GesconGerentesPagamentosDash,
        SgtecGestoresPainelErrosComprometimentosDash,
        SgtecGestoresEtapasDash01,
        GesconGerentesApoiosDash,
        GesconApoiosContratosDash,
        GesconApoiosRequisicoesDash,
        GesconApoiosPagamentosDash,
        DespesasRequisitanteDash,
        DespesasFornecedorDash,
        DespesasDemandanteDash,
        DespesasGerenteDash,
        DespesasFinalizacaoDash,
        DespesasFinanceiroDash,
        DespesasPagamentosFinalizacaoDash,
        DespesasPagamentosFinanceiroDash,
        DespesasPagamentosRequisitanteDash,
        DespesasPagamentosFornecedoresDash,
        DespesasPagamentosDemandantesDash,
        DespesasPagamentosGerentesDash
    },

    data() {
        return {
            loading: false,
            qtdSolicitacoesAcessoEmAprovacao: 0,
            qtdAtualizacoesCadastraisEmAprovacao: 0,
            qtdPagamentosProgramados: 0,
            qtdTotalAcessos: 0,
            qtdTotalAcessosAno: 0,
            qtdTotalAcessosMes: 0,
            qtdNovosFornecedoresAno: 0,
            qtdNovosFornecedoresMes: 0,
            qtdSolicitacoesAcessoAno: {},
            qtdSolicitacoesAcessoMes: {},
            qtdMensagensNaoLidas: 0,
            qtdContratacoesSemAvaliacao: 0,
            qtdEntregasSemComprometimento: 0,
            qtdEntregasErroComprometimento: 0,
            qtdContratacoesVencimentoEntre14e10Dias: 0,
            qtdSolicitacoesAditivosEmProcessamento: 0,
            qtdSolicitacoesReaberturasEmAnalisePeloGerente: 0,
            qtdSolicitacoesReaberturasEmAnalisePelaUabs: 0,
            qtdPagamentosEmAnaliseGescon: 0,
            qtdPagamentosAguardandoFinanceiroGescon: 0,
            qtdComprometimentosEmAnaliseGescon: 0,
            qtdPagamentosEmAnaliseUabsSgf: 0,
            qtdPagamentosEmAnaliseUfiSgf: 0,
            qtdPagamentosAguardandoFinanceiroUfiSgf: 0,
            qtdPagamentosEmAnaliseUabsSgtec: 0,
            qtdPagamentosEmAnaliseUfiSgtec: 0,
            qtdPagamentosAguardandoFinanceiroUfiSgtec: 0,
            qtdEtapasVencimentoEntre14e10diasNaoMarcadasNaoAditivar: 0,
            qtdPagamentosEmAnaliseUabsDespesasGerais: 0,
            qtdPagamentosEmAnaliseUfiDespesasGerais: 0,
            qtdPagamentosAguardandoFinanceiroUfiDespesasGerais: 0,
            qtdDespesasEmAnaliseGerDespesasGerais: 0,
            qtdDespesasEmAnaliseDemanDespesasGerais: 0,
            qtdRequisicoesContratosEmAnalise: 0
        }
    },

    methods: {
        obterDashboard() {
            this.loading = true
            DashboardServicos.obterDashboard().then((response) => {
                if (response) {
                    if (response.success) {
                        this.qtdSolicitacoesAcessoEmAprovacao =
                            response.data.QtdSolicitacoesAcessoEmAprovacao
                        this.qtdAtualizacoesCadastraisEmAprovacao =
                            response.data.QtdAtualizacoesCadastraisEmAprovacao
                        this.qtdPagamentosProgramados =
                            response.data.QtdPagamentosProgramados
                        this.qtdTotalAcessos = response.data.QtdTotalAcessos
                        this.qtdTotalAcessosAno =
                            response.data.QtdTotalAcessosAno
                        this.qtdTotalAcessosMes =
                            response.data.QtdTotalAcessosMes
                        this.qtdNovosFornecedoresAno =
                            response.data.QtdNovosFornecedoresAno
                        this.qtdNovosFornecedoresMes =
                            response.data.QtdNovosFornecedoresMes
                        this.qtdSolicitacoesAcessoAno = {
                            total: response.data.QtdSolicitacoesAcessoAno,
                            aprovadas:
                                response.data.QtdSolicitacoesAcessoAnoAprovadas,
                            reprovadas:
                                response.data.QtdSolicitacoesAcessoAnoReprovadas
                        }
                        this.qtdSolicitacoesAcessoMes = {
                            total: response.data.QtdSolicitacoesAcessoMes,
                            aprovadas:
                                response.data.QtdSolicitacoesAcessoMesAprovadas,
                            reprovadas:
                                response.data.QtdSolicitacoesAcessoMesReprovadas
                        }
                        this.qtdMensagensNaoLidas =
                            response.data.QtdMensagensNaoLidas

                        this.qtdContratacoesSemAvaliacao =
                            response.data.QtdContratacoesSemAvaliacao
                        this.qtdEntregasSemComprometimento =
                            response.data.QtdEntregasSemComprometimento
                        this.qtdEntregasErroComprometimento =
                            response.data.QtdEntregasErroComprometimento
                        this.qtdContratacoesVencimentoEntre14e10Dias =
                            response.data.QtdContratacoesVencimentoEntre14e10Dias
                        this.qtdSolicitacoesAditivosEmProcessamento =
                            response.data.QtdSolicitacoesAditivosEmProcessamento
                        this.qtdSolicitacoesReaberturasEmAnalisePeloGerente =
                            response.data.QtdSolicitacoesReaberturasEmAnalisePeloGerente
                        this.qtdSolicitacoesReaberturasEmAnalisePelaUabs =
                            response.data.QtdSolicitacoesReaberturasEmAnalisePelaUabs
                        this.qtdPagamentosEmAnaliseGescon =
                            response.data.QtdPagamentosEmAnaliseGescon
                        this.qtdPagamentosAguardandoFinanceiroGescon =
                            response.data.QtdPagamentosAguardandoFinanceiroGescon
                        this.qtdComprometimentosEmAnaliseGescon =
                            response.data.QtdComprometimentosEmAnaliseGescon
                        this.qtdPagamentosEmAnaliseUabsSgf =
                            response.data.QtdPagamentosEmAnaliseUabsSgf
                        this.qtdPagamentosEmAnaliseUfiSgf =
                            response.data.QtdPagamentosEmAnaliseUfiSgf
                        this.qtdPagamentosAguardandoFinanceiroUfiSgf =
                            response.data.QtdPagamentosAguardandoFinanceiroUfiSgf
                        this.qtdPagamentosEmAnaliseUabsSgtec =
                            response.data.QtdPagamentosEmAnaliseUabsSgtec
                        this.qtdPagamentosEmAnaliseUfiSgtec =
                            response.data.QtdPagamentosEmAnaliseUfiSgtec
                        this.qtdPagamentosAguardandoFinanceiroUfiSgtec =
                            response.data.QtdPagamentosAguardandoFinanceiroUfiSgtec
                        this.qtdEtapasVencimentoEntre14e10diasNaoMarcadasNaoAditivar = 
                            response.data.QtdEtapasVencimentoEntre14e10diasNaoMarcadasNaoAditivar
                        this.qtdPagamentosEmAnaliseUabsDespesasGerais =
                            response.data.QtdPagamentosEmAnaliseUabsDespesasGerais
                        this.qtdPagamentosEmAnaliseUfiDespesasGerais =
                            response.data.QtdPagamentosEmAnaliseUfiDespesasGerais
                        this.qtdPagamentosAguardandoFinanceiroUfiDespesasGerais =
                            response.data.QtdPagamentosAguardandoFinanceiroUfiDespesasGerais
                        this.qtdDespesasEmAnaliseDemanDespesasGerais =
                            response.data.QtdDespesasEmAnaliseDemanDespesasGerais
                        this.qtdDespesasEmAnaliseGerDespesasGerais =
                            response.data.QtdDespesasEmAnaliseGerDespesasGerais
                        this.qtdRequisicoesContratosEmAnalise = 
                            response.data.QtdRequisicoesContratosEmAnalise
                    }
                }
                this.loading = false
            })
        }
    },

    created() {
        this.obterDashboard()
    }
}
</script>
